type Props = { status: string; label?: string };

const STYLES: Record<string, { bg: string; dot: string; text: string }> = {
  new: { bg: "bg-primary-soft", dot: "bg-primary", text: "text-primary-hover" },
  in_review: { bg: "bg-warning-soft", dot: "bg-warning", text: "text-[#92400e]" },
  published: { bg: "bg-success-soft", dot: "bg-success", text: "text-[#166534]" },
  active: { bg: "bg-success-soft", dot: "bg-success", text: "text-[#166534]" },
  forwarded: { bg: "bg-success-soft", dot: "bg-success", text: "text-[#166534]" },
  filled: { bg: "bg-accent-soft", dot: "bg-accent", text: "text-[#6d28d9]" },
  closed: { bg: "bg-surface-alt", dot: "bg-text-soft", text: "text-text-muted" },
  declined: { bg: "bg-danger-soft", dot: "bg-danger", text: "text-[#b91c1c]" },
  skipped: { bg: "bg-surface-alt", dot: "bg-text-soft", text: "text-text-muted" },
};

const LABELS: Record<string, string> = {
  new: "New",
  in_review: "In review",
  published: "Published",
  active: "Active",
  filled: "Filled",
  closed: "Closed",
  forwarded: "Forwarded",
  declined: "Declined",
  skipped: "Skipped",
};

export function StatusTag({ status, label }: Props) {
  const style = STYLES[status] ?? {
    bg: "bg-surface-alt",
    dot: "bg-text-soft",
    text: "text-text-muted",
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${style.bg} ${style.text}`}
    >
      <span className={`size-1.5 rounded-full ${style.dot}`} />
      {label ?? LABELS[status] ?? status}
    </span>
  );
}
